import React, {useEffect, useState} from 'react';
import {updateHeader, updateUrl, hideEditProduct} from '../../../store/actions/main';
import {updateModellIndexTore} from '../../../store/actions/tore';
import {connect} from 'react-redux';
import ModalPopUp from '../../../module/modalPopUp';
import Button from '@material-ui/core/Button';
import ImageSlider from '../../../module/imageSlider';
import {ProductInfo} from '../../../module/productInfo';
import {StepComponent} from '../../../module/step_component';
import {tore_auswahl} from '../../../../assets/images/data';

const Index = (props) => {
    const [showModalStepper, setShowModalStepper] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [showModalImages, setModalImages] = useState(false);
    const [modell_index, setIndexModell] = useState(0);

    const closeModalStepper = () => setShowModalStepper(false);
    const closeModalInfo = () => setShowModalInfo(false);
    const closeModalImages = () => setModalImages(false);

    useEffect(() => {
        updateItems();
    })

    const updateItems = () => {
        props.updateHeader('Tore');
        editProduct();
    }

    const editProduct = () => {
        let edit_modell_index = props.main_data[3].editProduct[0].editProductIndex;
        let isEditProduct = props.main_data[3].editProduct[0].isEditProduct;
        let product = document.querySelectorAll('.stepper-button');

        if (isEditProduct) {
            props.updateUrl('Tore');
            props.updateModellIndex(edit_modell_index);
            product[edit_modell_index].click();
            // setShowModalStepper(true);
            props.hideEditProduct();
        }

    }

    const showStepper = ev => {
        let modell_index = ev.currentTarget.getAttribute('index');
        props.updateUrl('Tore');
        props.updateModellIndex(modell_index);
        setShowModalStepper(true);
    }

    const showInfo = ev => {
        let index = ev.currentTarget.getAttribute('index');
        props.updateModellIndex(index);
        setIndexModell(Number(index));
        setShowModalInfo(true);
    }

    const showImages = ev => {
        setIndexModell(Number(ev));
        setModalImages(true);
    }

    return (
        <div className='product_main_wrapper'>
             <h2>Schiebe- oder Flügeltor?</h2>
             <div className='product_wrapper'>
                {tore_auswahl.map((elem, index) => (
                        <div key={index} className='inner-modell-wrapper'>
                            <p className="titel">{elem.titel}</p>
                            <ImageSlider
                                showImages={() => showImages(index)}
                                imageposter={elem.portfolio}
                                videoposter={elem.videos}
                                switchButtonLabelLeft="Bilder"
                                switchButtonLabelRight="Videos"
                                videoindex={index}
                            />
                            <div className="button-wrapper">
                                <Button onClick={showStepper} index={index} className='button stepper-button'>Konfigurator starten</Button>
                                <Button onClick={showInfo} index={index} className='button info'>Mehr Informationen</Button>
                            </div>
                        </div>
                    ))}
                </div>
                <ModalPopUp
                    title={tore_auswahl[modell_index].titel+" - Bilder"}
                    class='modell'
                    component={<ImageSlider showModalImages={showModalImages} imageposter={tore_auswahl[modell_index].portfolio} />}
                    showModal={showModalImages}
                    hideModal={closeModalImages}
                />
                <ModalPopUp
                    title={tore_auswahl[modell_index].titel}
                    class='modell'
                    component={<StepComponent />}
                    showModal={showModalStepper}
                    hideModal={closeModalStepper}
                />
                <ModalPopUp
                     title={"Produktbeschreibung - "+tore_auswahl[modell_index].titel}
                     class='modell'
                     component={<ProductInfo
                                 type={"ein "+tore_auswahl[modell_index].titel}
                                 desc={tore_auswahl[modell_index].desc}
                                 desc_items={tore_auswahl[modell_index].content}
                                 price={`Ab ${tore_auswahl[modell_index].price.toFixed(2)}€`}
                                 />}
                     showModal={showModalInfo}
                     hideModal={closeModalInfo}
               />
        </div>
    )
}

const mapStateToProps = state => {
    return {
        main_data: state.mainReducer.data,
    }
}

const mapStateToDispatch = dispatch => {
    return {
        updateHeader: ev => dispatch(updateHeader(ev)),
        updateUrl: ev => dispatch(updateUrl(ev)),
        hideEditProduct: () => dispatch(hideEditProduct()),
        updateModellIndex: ev => dispatch(updateModellIndexTore(ev))

    }
}

export default connect(mapStateToProps, mapStateToDispatch)(Index);